export default "__VITE_ASSET__122672cc__"